/**
 * Created by YingJieCHAI on 2018/5/17.
 */
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home.component';
export const homeRoutes=[
  {
    path:'',
    component:HomeComponent
  }
];
